var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-layout type-report"},[_c('main-navbar'),_c('div',{staticClass:"wrapper report",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('template',{slot:"links"},[_c('div',{staticClass:"profiles"},[_c('sidebar-item',{staticClass:"sidebar-item-plus",attrs:{"link":{
              name: 'Prospect Search',
              icon: 'source',
              path: '/prospect-search',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Financial',
              icon: 'card_travel',
              path: '/new-profile/industry-financial-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Market',
              icon: 'leaderboard',
              path: '/new-profile/industry-market-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Companies',
              icon: 'business',
              path: '/company-search',
            }}}),_c('div',{staticClass:"disable"},[_c('sidebar-item',{attrs:{"link":{
                name: 'Market',
                icon: 'insights',
                path: '/',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Franchise',
                icon: 'store',
                path: '/',
              }}})],1),_c('sidebar-item',{attrs:{"link":{
              name: 'Financial Report',
              icon: 'text_snippet',
              path: '/create-report-format/financial',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Market Report',
              icon: 'newspaper',
              path: '/create-report-format/market',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Valuation Report',
              icon: 'request_quote',
              path: '/create-report-format/valuation',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Company Report',
              icon: 'summarize',
              path: '/create-report-format/company',
            }}})],1),_c('div',{staticClass:"section_wpr"},[_vm._v("My Data")]),_c('div',{staticClass:"profiles border-0"},[_c('sidebar-item',{attrs:{"link":{
              name: 'Prospect List',
              icon: 'format_list_bulleted',
              path: '/my-prospect-lists',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Profiles',
              icon: 'folder_open',
              path: '/my-profiles',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Reports',
              icon: 'description',
              path: '/my-reports',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Data',
              icon: 'dns',
              path: '/my-data',
            }}})],1)])],2),_c('app-side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'About the Data',
            icon: 'help',
            path:
              '/valuation-report/' + this.id + '/vestimate-report-about-data',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Business Value',
            icon: 'developer_board',
            path: '/valuation-report/' + this.id + '/business-value',
            type: 'product',
          }}}),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'swot-analysis' }),expression:"{ name: 'swot-analysis' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Scores',
              icon: 'star_half',
              path: '/valuation-report/' + this.id + '/scores',
              type: 'product',
            }}})],1),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'company-context' }),expression:"{ name: 'company-context' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Company-Context',
              icon: 'broken_image',
              path: '/valuation-report/' + this.id + '/company-context',
              type: 'product',
            }}})],1),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'market-insights' }),expression:"{ name: 'market-insights' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Market Environment',
              icon: 'receipt_long',
              path: '/valuation-report/' + this.id + '/market-environment',
              type: 'product',
            }}})],1),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Financial Analysis',
            icon: 'pie_chart',
            path: '/valuation-report/' + this.id + '/finanical-analysis',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'KPI Details',
            icon: 'scatter_plot',
            path: '/valuation-report/' + this.id + '/kpi-details',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Valuation Approach',
            icon: 'info',
            path: '/valuation-report/' + this.id + '/vestimate-approach',
            type: 'product',
          }}}),_c('sidebar-item',{class:_vm.loading || this.isRetail ? 'non-subscriber' : '',attrs:{"link":{
            name: 'Customize Report',
            icon: 'tune',
            path: !this.isRetail
              ? '/valuation-report/' + this.id + '/vestimate-customize-report'
              : this.currentPath,
            type: this.isRetail ? 'disabled' : 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Manage Inputs',
            icon: 'settings',
            path: '/valuation-report/' + this.id + '/vestimate-manage-inputs',
            type: 'product',
          }}})],1)],2),_c('div',{staticClass:"main-panel"},[_c('div',{class:{ content: !_vm.$route.meta.hideContent }},[(!_vm.isAboutRoute)?_c('div',{staticClass:"content"},[_c('PulseLoader',{class:{ hide: !_vm.loading },attrs:{"loading":_vm.loading,"quote":"Action is the foundational key to all success","author":"Pablo Picasso","profession":"Spanish Painter","img":"picasso.jpg"}})],1):_vm._e(),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('div',{staticClass:"row"},[(!_vm.loading || _vm.isAboutRoute)?_c('router-view',{attrs:{"headerData":_vm.headerData}}):_vm._e()],1)])],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }